import { Building2 } from "lucide-react";
import FolderView from "@/components/FolderView";


import TopNav from "@/components/TopNav";
const FOLDERS = [
  "SOPs", "Forms", "Templates", "Manuals", "Policies",
  "Guidelines", "Plans", "Strategies", "MoU", "MoA",
];

export default function InternalMatters() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
            <Building2 className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-['Barlow_Condensed'] text-3xl font-bold text-app tracking-wide">
              INTERNAL MATTERS
            </h1>
            <p className="text-app">SOPs, Forms, Policies, Plans & internal documentation</p>
          </div>
        </div>
      </div>

      <FolderView subHub="internal-matters" folders={FOLDERS} icon={Building2} color="blue" />
    </div>
  );
}
